import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { Idaycalculation } from "../../../Pages/ExamDate/IExamDate";

export const ListdaycalculationSlice = createSlice({
  name: "ListdaycalculationSlice",
  initialState: {} as IReduxState<Idaycalculation[]>,
  reducers: {
    listdaycalculation: (state) => {
      state.isLoading = true;
    },
    successlistdaycalculation: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failurelistdaycalculation: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  failurelistdaycalculation,
  listdaycalculation,
  successlistdaycalculation,
} = ListdaycalculationSlice.actions;

export default ListdaycalculationSlice.reducer;
